export const LOCALES = ['de'] as const;
